import { render, staticRenderFns } from "./BatchHandleDialog.vue?vue&type=template&id=55d44ff0&"
import script from "./BatchHandleDialog.vue?vue&type=script&lang=js&"
export * from "./BatchHandleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports